module.exports = __webpack_public_path__ + "static/media/contrast.a7cd350e.svg";